module.exports = __webpack_public_path__ + "static/media/navidad13.734af5d6.jpg";